import * as React from "react";
import { formatDistance, subHours } from "date-fns";
import { getRecentDonations } from "../../common/routes";
import { RecentDontion } from "../../common/types";
import { useInterval } from "@flow/lib/use_interval";
import { Favorite } from "@mui/icons-material";
// import { Avatar, Stack, Typography, Box } from "@mui/material";
import { Avatar, Stack, Typography } from "@mui/material";

export function RecentDonations(props: { journeyGuid: string }) {
  const [recentDonations, setRecentDonations] = React.useState<RecentDontion[]>([]);
  const [activeDonation, setActiveDonation] = React.useState<RecentDontion | undefined>(undefined);
  const [idx, setIdx] = React.useState<number>(0);

  const oneHourAgo = subHours(new Date(), 1);

  // We grab the last 10 donations...
  React.useEffect(() => {
    setRecentDonations([]);
    getRecentDonations.call({ journeyGuid: props.journeyGuid }).then((donations) => {
      setIdx((idx + 1) % donations.length);
      setRecentDonations(donations);
      setActiveDonation(donations[idx]);
    });
  }, [props.journeyGuid]);

  // Loop through these donations every 2 seconds...
  useInterval(() => {
    setIdx((idx + 1) % recentDonations.length);
    setActiveDonation(recentDonations[idx]);
  }, 2000);

  const donationText = (activeDonation: RecentDontion) => {
    return `donated £${activeDonation.amount}${
      activeDonation.created_at <= oneHourAgo ? "" : ` ${formatDistance(activeDonation.created_at, new Date())} ago`
    }`;
  };

  const renderDonor = () => {
    return (
      activeDonation &&
      hasRecentDonations(recentDonations) && (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ minHeight: "2rem" }}>
          <Avatar
            sx={{
              height: "1.5rem",
              width: "1.5rem",
              background: "#F5F5F5",
            }}
          >
            <Favorite sx={{ color: "red", height: "75%" }} />
          </Avatar>
          <Typography variant="body2">
            <strong>{activeDonation.name}</strong> {donationText(activeDonation)}
          </Typography>
        </Stack>
      )
    );
  };

  return <div>{renderDonor()}</div>;
}

const hasRecentDonations = (donations: RecentDontion[]) => donations.length > 0;
